import { Navigate, useSearchParams } from 'react-router-dom';
import { Bell, KeyRound, ShieldCheck, SlidersHorizontal } from 'lucide-react';
import { SectionLayout, type SectionNavGroup } from '../components/SectionLayout';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

// Route sections live under ./settings/ (one file per route). Re-exported here
// so App.tsx and the settings tests keep importing them from './SettingsPage'.
export { GeneralSettingsSection } from './settings/GeneralSettingsSection';
export { NotificationsSettingsSection } from './settings/NotificationsSettingsSection';
export { McpSettingsSection } from './settings/McpSettingsSection';
export { SecuritySettingsSection } from './settings/SecuritySettingsSection';

const SETTINGS_GROUPS: SectionNavGroup[] = [
  {
    items: [
      { to: '/settings/general', label: 'General', icon: SlidersHorizontal },
      { to: '/settings/notifications', label: 'Notifications', icon: Bell },
      { to: '/settings/mcp', label: 'MCP', icon: KeyRound },
      { to: '/settings/security', label: 'Security', icon: ShieldCheck },
    ],
  },
];

export function SettingsPage() {
  useDocumentTitle('Settings');
  const [searchParams] = useSearchParams();

  // Redirect legacy ?tab= URLs to the new nested routes.
  const tabParam = searchParams.get('tab');
  if (
    tabParam &&
    SETTINGS_GROUPS.some((g) => g.items.some((t) => t.to === `/settings/${tabParam}`))
  ) {
    return <Navigate to={`/settings/${tabParam}`} replace />;
  }

  return (
    <SectionLayout
      title="Settings"
      subtitle="Credentials are encrypted at rest (AES-256-GCM) and never returned by the API — you only see whether each one is configured. The Agent, GitHub, and Telegram tokens are scoped to the current workspace."
      ariaLabel="Settings sections"
      groups={SETTINGS_GROUPS}
    />
  );
}
